import { useMutation } from "@tanstack/react-query";
import { api } from "../lib/api";

interface InitialSchedulePullParams {
  fhirUrl: string;
  sta3n: string;
}

export interface InitialSchedulePullResponse {
  appointments_found: number;
  new_patients_added: number;
  patients_reactivated: number;
  appointments_cancelled: number;
  appointments_scheduled_elsewhere: number;
  appointments_cancelled_at_current_facility: number;
  appointments_skipped: number;
  days_searched: string;
  processing_time: string;
  error?: string;
  message?: string;
  [key: string]: unknown;
}

export function useInitialSchedulePull() {
  return useMutation({
    mutationFn: async ({ fhirUrl, sta3n }: InitialSchedulePullParams) => {
      return api.post<InitialSchedulePullResponse>("/va/new-schedule-pull", {
        fhirUrl,
        sta3n,
      });
    },
  });
}

export default useInitialSchedulePull;
